"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items } = element.value;
    const lines = [];
    items.forEach((item) => {
        let label = item.label
            ? (0, rich_text_1.slateToMarkdown)(item.label, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim()
            : '';
        label = (0, md_utils_1.sanitizeInlineMd)(label);
        if (label) {
            lines.push(`- [ ] ${label}`);
        }
    });
    if (lines.length === 0) {
        return '';
    }
    return lines.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
